import { render } from "./AddUser.vue?vue&type=template&id=edd414ce&scoped=true"
import script from "./AddUser.vue?vue&type=script&lang=js"
export * from "./AddUser.vue?vue&type=script&lang=js"

import "./../../../assets/styles/admin/users/addUser.scss?vue&type=style&index=0&id=edd414ce&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-edd414ce"]])

export default __exports__